module.exports = __webpack_public_path__ + "static/media/visa-mastercard-icon.cf334292.svg";